import React         from 'react'
import prettysize    from '../../../utils'
import { Draggable } from 'react-beautiful-dnd'
import classnames    from "classnames"
import { Checkbox, Button, Icon, Tooltip } from 'antd'

import './styles.scss'

let get_item_style = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  background: isDragging ? '' : '',
  ...draggableStyle
})

export default ({file, selection_count, droppable_id, on_play_video, on_select, on_download, on_delete,
                  on_share, on_open_encode, on_expand_options, is_ghosting, on_navigate, on_open_hybrik,
                    on_show_media_info, on_move, index, is_drag_disabled }) => {
  let {size, basename, name, key, path} = file
  name = basename||key||name
  return (
    <Draggable draggableId    = {droppable_id + path}
               key            = {droppable_id + path}
               index          = {index}
               isDragDisabled = {is_drag_disabled}>
      {(provided, snapshot) => {
        return (
          <a className={classnames({
            'file-item' : true,
            'columnWrap': true,
            'checked'   : file.checked,
            'ghosting'  : file.checked && is_ghosting,
            'dragging'  : snapshot.isDragging,
            'pasted'    : file.pasted
          })}
             onDoubleClick={() => size !== null ? on_expand_options(file) : on_navigate(file)}
             onClick={() => on_select(file, !file.checked)}
             ref={provided.innerRef}
             {...provided.draggableProps}
             {...provided.dragHandleProps}
             style={get_item_style(
               snapshot.isDragging,
               provided.draggableProps.style
             )}>

            {size === null ? <Icon type="folder"/> : <Icon type="file-text"/>}
            <span>{name}</span>
            {
              size !== null ?
                file.expand_options ? (
                  <div className={'options ' + file.expand_options ? 'expand' : ''}>

                    <Tooltip title="Media Info">
                      <Button ghost icon="info-circle-o" size={'small'} onClick={() => on_show_media_info(file)}/>
                    </Tooltip>

                    <Button ghost icon="close" size={'small'} onClick={() => on_expand_options(file)}/>
                  </div>
                ) : (
                  <div className={'cmds'}>
                    <span className='size'>{prettysize(size)}</span>
                    <Checkbox checked={file.checked} onChange={(e) => on_select(file, e.target.checked)}/>
                    <Button icon="ellipsis" size={'small'} className={'ellipsis'}
                            onClick={() => on_expand_options(file)}/>
                  </div>
                ) : null
            }
            {
              (selection_count > 1 && snapshot.isDragging && file.checked) ?
                <div className={'badge'}>{selection_count}</div>:null
            }
          </a>
        )
      }}
    </Draggable>
  )
}
